import React, {FC, memo} from 'react';
import {useHistory} from 'react-router-dom';
import {
  Product,
  ProductCategory,
  useCurrentCategory,
  useCurrentProduct,
  useCurrentSelectedOptions,
} from '../../contexts/Quote';
import {productCategories} from './data';
import ProductSelection from './ProductSelection';

const ProductCategories: FC<{parentPath: string}> = ({parentPath}) => {
  const [category, setCategory] = useCurrentCategory();
  const [product, setProduct] = useCurrentProduct();
  const [_, setSelectedOptions] = useCurrentSelectedOptions();
  const history = useHistory();

  const onSelect = (_category: ProductCategory): void => {
    if(_category !== category) {
      setSelectedOptions([]);
      setCategory(_category);

      if (product && !_category.products.includes(product)) {
        setProduct((undefined as unknown) as Product);
      }
    }

    history.push(`${parentPath}/products`);
  };

  return (
    <ProductSelection
      products={productCategories}
      onSelect={onSelect}
      value={category || undefined}
    />
  );
};

export default memo(ProductCategories);
